/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-04 14:44:27
 */

import * as request from '@/utils/request'

export default {
  getUserList(data) {
    return request.post('/user/list',data)
  },
  saveUser(data) {
    return request.post('/user/store',data)
  },
  getUserInfo(id) {
    let data = {id:id}
    return request.post('/user/get_info',data)
  },
  deleteUser(id) {
    let data = {id:id}
    return request.post('/user/delete',data)
  },
  getUserRoles() {
    return request.post('/user/get_roles')
  },
  userSwitch(company_id, settlement_id) {
    let data = {
      company_id: company_id,
      settlement_id: settlement_id,
    }
    return request.post('/user/switch', data)
  },
  getUserProfile() {
    return request.get('/user/profile')
  },
  setUserProfile(data) {
    return request.post('/user/profile', data)
  },
  // 商户和服务公司在一起
  getUserCompanySettlement() {
    return request.get('/user/new_get_company')
  },
  getProfileNew() {
    return request.get('/user/new_get_profile')
  },
  getUserCompany() {
    return request.get('/user/get_company')
  },
  getUserSettlement(data) {
    return request.get('/user/get_settlement', data)
  },
  changeWarning(data) {
    return request.post('/user/change_warning', data)
  }
}